import { w as withConfigTransport } from "../../../services/config-transport/withConfigTransport-2705a6a5.mjs";
import { _ as _sfc_main } from "./VaTimelineSeparator.vue_vue_type_script_lang-6fbeb75c.mjs";
const VaTimelineSeparator = withConfigTransport(_sfc_main);
export {
  VaTimelineSeparator as V
};
//# sourceMappingURL=index-b6d817fe.mjs.map
